import { render, staticRenderFns } from "./PromoCarousel.vue?vue&type=template&id=484120c4&scoped=true&"
import script from "./PromoCarousel.vue?vue&type=script&lang=js&"
export * from "./PromoCarousel.vue?vue&type=script&lang=js&"
import style0 from "./PromoCarousel.vue?vue&type=style&index=0&id=484120c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484120c4",
  null
  
)

export default component.exports